import { AuthenticationReq, CommonResponse, ForgotPasswordReq, LoginReq, ResetPasswordReq } from "@boi/shared-models";
import { CommonAxiosService } from "../common-axios-service";

export class AuthenticationsService extends CommonAxiosService {
    private controller = '/authentications';

    async createAuthentication(req: AuthenticationReq): Promise<CommonResponse> {
        return this.axiosPostCall(this.controller + "/createAuthentication", req);
    }
  
    async UpdateAuthentication(req: AuthenticationReq): Promise<CommonResponse> {
        return this.axiosPostCall(this.controller + "/UpdateAuthentication", req);
    }

    async login(req: LoginReq): Promise<CommonResponse> {
        return this.axiosPostCall(this.controller + "/login", req);
    }

    async forgotPassword(req: ForgotPasswordReq): Promise<CommonResponse> {
        return this.axiosPostCall(this.controller + "/forgot-password", req);
    }

    async resetPassword(req: ResetPasswordReq): Promise<CommonResponse> {
        return this.axiosPostCall(this.controller + "/resetPassword", req);
    }
  
    async getAllUsers(req:any): Promise<CommonResponse> {
        return this.axiosPostCall(this.controller + "/getAllUsers",req);
    }

    async checkPhoneNoAlreadyExist(req: { phoneNo: string }): Promise<CommonResponse> {
        return this.axiosPostCall(this.controller + "/checkPhoneNoAlreadyExist", req);
    }

}
